import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo-blue-1-s1.png';
import { resetSurvey } from '../store/features/CreateSurveySlice';
import { useAppDispatch, useAppSelector } from '../store/store';
import Modal from '../Components/Modal';
import { FaGoogle } from 'react-icons/fa';
import { signInWithGoogle } from '../Firebase/utils';
import { setUser } from '../store/features/UserSlice';
import { User } from '../types';

const Home = () => {

    const user = useAppSelector((state) => state.user.user);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [isSignInModalOpen, setIsSignInModalOpen] = React.useState(false);

    const handleNavigate = (path: string) => {
      if(user.uid === ''){
          setIsSignInModalOpen(true);
          return;
      }
      navigate(path);
    }

  const handleGoogleSignIn = async () => {
    const {...user} = await signInWithGoogle() as User;
    if (user) {
        dispatch(setUser(user));
        setIsSignInModalOpen(false);
        setIsSignInModalOpen(false);
    }
};

  return (
    <div className='flex flex-col moving-gradient-container'>
      <header className='flex flex-col md:flex-row justify-center items-center gap-3 md:gap-10 text-[#3da8e2] text-center pt-10 md:pt-20'>
        <img src={logo} alt='Survey M3 Logo' className='w-20 h-20 md:w-40 md:h-40 img-shadow' />
        <div className='flex flex-col gap-4'>
          <h1 className='text-6xl md:text-9xl font-Velocity tracking-widest text-shadow-lg text-slate-300'>SURV<span className='text-[#3da8e2]'>E</span>Y M<span className='text-[#3da8e2]'>3</span></h1>
          <h2 className='text-white text-lg md:text-3xl font-BCBold'>Design Surveys, Capture Insights, Make Decisions.</h2>
        </div>
      </header>
      <section className='flex-grow flex flex-col justify-center items-center gap-20 my-16 md:my-36'>
        <button onClick={() => {handleNavigate('/survey-builder'); }} className='w-11/12 md:w-1/2 bg-[#3da8e2] text-white p-4 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest'>Survey Builder</button>
        <button onClick={() => {handleNavigate('/manage-surveys'); }} className='w-11/12 md:w-1/2 bg-[#3da8e2] text-white p-4 rounded-md border-[#aad4ea] border shadow-black shadow-lg font-BardotBold tracking-widest'>Manage Surveys</button>
        <button onClick={() => {handleNavigate('/complete-survey'); }} className='w-11/12 md:w-1/2 bg-[#3da8e2] text-white p-4 rounded-md border-[#aad4ea] border shadow-black shadow-lg font-BardotBold tracking-widest'>Complete a Survey</button>
      </section>
      <Modal title='Please Sign In' onClose={() => { setIsSignInModalOpen(false) }} openState={isSignInModalOpen} left={'-left-5'}>
              <button onClick={() => handleGoogleSignIn()} className='flex flex-row gap-10 w-full items-center justify-center mt-10 py-2 text-lg md:text-xl uppercase font-SoulGaze tracking-wider text-slate-300 border border-slate-400 rounded-md'>
                  <p className='flex gap-4 items-center text-[#3da8e2] font-BardotBold tracking-[0.25rem]'><FaGoogle className='text-2xl'/>Signin With Google</p>
              </button>
      </Modal>
    </div>
  );
};

export default Home;